<template>
  <div class="home">
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-item
          :complete="step > 1"
          :value="1"
          :editable="step > 1"
          edit-icon="mdi-map-marker"
          color="#102a63"
          title="Provincia"
        >
        </v-stepper-item>

        <v-divider></v-divider>

        <v-stepper-item
          :complete="step > 2"
          :value="2"
          :editable="step > 2"
          edit-icon="mdi-office-building-marker-outline"
          color="#102a63"
          title="Filiale"
        >
        </v-stepper-item>

        <v-divider></v-divider>

        <v-stepper-item :value="3" color="#102a63" title="Dettaglio">
        </v-stepper-item>
      </v-stepper-header>

      <v-stepper-window class="pa-0 ma-0">
        <v-stepper-window-item :value="1" class="pa-0 ma-0">
          <provincia-selector v-on:select="setProvincia($event)" />
        </v-stepper-window-item>

        <v-stepper-window-item :value="2" class="pa-0 ma-0">
          <filiale-selector
            :provincia="provincia"
            v-on:select="setFiliale($event)"
          />
        </v-stepper-window-item>

        <v-stepper-window-item :value="3" class="pa-0 ma-0">
          <MSBookingsFrame v-if="step == 3" />
        </v-stepper-window-item>
      </v-stepper-window>
    </v-stepper>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import FilialeSelector from "@/components/FilialeSelector.vue";
import ProvinciaSelector from "@/components/ProvinciaSelector.vue";
import { Filiale } from "@/models/filiale";
import { useBookingStore } from "./store";
import MSBookingsFrame from "@/components/MSBookingsFrame.vue";
import { GetFiliali } from "@/services/FilialiProvider";

const bookingStore = useBookingStore();

const step = ref(1);

GetFiliali().then((ff) => {
  bookingStore.SET_FILIALI(ff);
});

const provincia = computed<string>({
  get: (): string => {
    const p = bookingStore.Provincia;
    return p === undefined ? "" : p;
  },
  set: (value: string): void => {
    bookingStore.SET_PROVINCIA(value);
  },
});

function setProvincia(value: string) {
  filiale.value = undefined;
  provincia.value = value;
  step.value = 2;
}

const filiale = computed<{ filiale: Filiale; pos: number } | undefined>({
  get: (): { filiale: Filiale; pos: number } | undefined => {
    return bookingStore.Filiale;
  },
  set: (event: { filiale: Filiale; pos: number } | undefined): void => {
    if (process.env.VUE_APP_DEMO === "true" && event !== undefined) {
      event.filiale.PublicUrl =
        event.pos % 2 == 0
          ? "https://outlook.office365.com/owa/calendar/BAPSFilialediTest2@progesoftware.it/bookings/"
          : "https://outlook.office365.com/book/Test11@progesoftware.it/";
      event.filiale.BookingsId =
        event.pos % 2 == 0
          ? "FilialediRagusa2@progesoftware.it"
          : "ProgeSoftwaresrl52@progesoftware.it";
    }
    bookingStore.SET_FILIALE(event);
  },
});

function setFiliale(event: { filiale: Filiale; pos: number }) {
  filiale.value = event;
  step.value = 3;
}
</script>
